const PermissionsForProfileModel = Backbone.Model.extend({
  sync(method, model, options) {
    let params = null;

    if (method === 'read') {
      // Copy the "options" argument minus properties specified in the omit array
      params = _.omit($.extend(true, {}, options), ['parse', 'success', 'error']);

      Sendible.Connect.permissionProfile('', $username, $password, params, (data) => {
        options.success(data);
      }, (data) => {
        options.error(data);
      });
    }

    if (method == 'update') {
      params = _.omit($.extend(true, {}, options), ['parse', 'success', 'error', 'validate']);

      Sendible.Connect.updatePermissionProfile('', $username, $password, params, (data) => {
        options.success(data);
      }, (data) => {
        options.error(data);
      });
    }

    if (method == 'create') {
      params = _.omit($.extend(true, {}, options), ['parse', 'success', 'error', 'validate']);

      Sendible.Connect.createPermissionProfile('', $username, $password, params, (data) => {
        options.success(data);
      }, (data) => {
        options.error(data);
      });
    }

    if (method == 'delete') {
      params = _.omit($.extend(true, {}, options), ['parse', 'success', 'error', 'validate', 'view']);

      Sendible.Connect.deletePermissionProfile('', $username, $password, params, (data) => {
        options.success(data);
      }, (data) => {
        if (typeof data === 'string') {
          model.trigger('InUseError', data);
          return;
        } if (data.error && data.error.message) {
          model.trigger('InUseError', data.error.message);
          return;
        }
        options.error(data);
      });
    }
  },
});

export default PermissionsForProfileModel;
